export default class Input
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Input.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$el.addEventListener('change', this.onInput.bind(this))
        this.DOM.$el.addEventListener('keyup', this.onInput.bind(this))
        setTimeout(this.onInput.bind(this), 10)
    }

    onInput() {
        const val = this.DOM.$el.value
        const isDirty = (val !== this.DOM.$el.defaultValue)
        const isEmpty = (val.length === 0)

        this.DOM.$el.classList.toggle(this.options.classNameIsDirty, isDirty)
        this.DOM.$el.classList.toggle(this.options.classNameIsEmpty, isEmpty)
    }
}

Input.prototype.defaults = {
    classNameIsDirty: 'is-dirty',
    classNameIsEmpty: 'is-empty',
}